import { createI18n } from "vue-i18n";

const messages = {
  en: {
    partner: {
      heading: "FACE's ecosystem partners",
      link: "Visit",
    },
    consent: {
      reapply: {
        selection_zero: "Select a reason",
        selection_one:
          "I have updated financial or tax information about my company to support a new application.",
        selection_two:
          "I have a loan from FACE and want to apply for more capital.",
        reason: "Please select below the reason for your new loan application.",
        error: "You must consent to proceed with the application.",
        selection: "You must select a reason to proceed with the application.",
        button: "Re-Apply",
        heading: "By submitting this application,",
        row1: "I/We authorize FACE to obtain credit reports and any information they may require in connection with this request for credit and any update, increase, renewal, extension, or collection of the credit received, from other sources (including, for example, credit bureau) and each such source is hereby authorized to provide them with such information.",
        row2: "I/We hereby certify that the information given in the application is true and correct and I/We understand that FACE will rely on the information in this application and on my credit reports to make its decision.",
        row3: "I/We acknowledge that any reapplication which contains no changes or updates may be subject to an immediate decline.",
        row4: "I/We acknowledge that I/we are fully responsible and will be held fully liable if I/we willfully and deliberately provide incomplete or incorrect information on loan applications made to FACE.",
      },
      mandatory: "* Mandatory",
      heading: "User consent",
      check: "Check this box if you consent.",
      error:
        "You must consent to the mandatory section to proceed with the application.",
      button: "I Authorize",
      cancel: "Cancel",
      one: {
        heading: "Business listing in-take",
        info: "I consent that the information I am providing about my business in this section will be used to list and map my company on the FACE platform for public use.",
      },
      two: {
        heading: "Personal in-take questionnaire",
        info: "I am aware that ALL the questions in this section are not mandatory and will not be shared or used to assess my loan application at FACE.",
      },
      three: {
        heading: "Business and shareholders in-take",
        info: "I am aware that ALL the questions in this section are mandatory and requested documents are required to submit my loan application at FACE.",
      },
    },
    question: {
      shareholders: "Business shareholders information",
      required: "Business shareholders information is required.",
      input: {
        name: "Full name",
        email: "Email address",
        dob: "Date of birth",
        address: "Business address",
        share: "Share",
      },
    },
    menu: {
      home: "Home",
      dashboard: "Dashboard",
      login: "Login",
      logout: "Sign out",
      settings: "Settings",
      profile: "Your Profile",
      profile2: "Profile",
      privacy: "Privacy",
      resources: "Resources",
      security: "Security",
      faq: "FAQ",
      help: "Help",
      legal: "Legal",
    },
    locale: "en",
    "personal-networth": "Personal net worth statement",
    "app-file": "Fillable PDF form",
    faq: "Faq",
    legal: "Legal",
    privacy: "Privacy",
    security: "Security",
    help: "Help",
    copyright: "FACE - Federation of African Canadian Economics",
    login: "Login",
    logout: "Logout",
    input: {
      type: "Type something here...",
      delete: "Delete",
      preview: "Preview your uploaded documentation.",
      btnpreview: "Preview",
      allq: "All Questions",
      edit: "Edit",
      alld: "All Documents",
      uploadedd: "Uploaded documents",
      uploaddoc: "Upload your document",
      oops: "Oops!",
      required: "This question is mandatory.",
      requiredAmount: "Loan amount must be more than or equal to $10,000",
      enter: "Enter",
      save: "Save",
      update: "Update",
      saving: "Saving",
      continue: "Continue",
      skip: "Skip Question",
    },
    drop: "Upload your document",
    drop2: "Upload your document",
    continue: "Continue",
    complete: "Complete",
    completed: "Document submitted",
    questions: "Questions",
    questionsTotal: "Total",
    questionsRequired: "Mandatory",
    files: "Files",
    upload: "Upload",
    download: "Download Document",
    response: "Response",
    cancel: "Cancel",
    reply: "Reply",
    dashboard: {
      enable: "Enable",
      "loan-app": "Loan Application",
      submitted: "Submission Date ",
      "sms-info":
        "Learn how the fraud is affecting businesses and the strategies you can take to prevent new account abuse, account takeovers, and transaction fraud.",
      "upload-doc": "Upload your document",
      status: {
        review: "Our Officers are currently reviewing your file.",
      },
      comm: "Requests",
      process: "Application status",
      "edit-app": "Edit Application",
      "start-app": "Start Application",
      of: "of",
      "mapping-title": "Black Business Registration & Mapping",
      "mapping-sub":
        "Increase your business exposure and list your business or services through FACE Coalition.",
      "notify-sms": "Notify me through SMS",
      sub: "Increase your business exposure and list your business or services through FACE Coalition.",
      review: "Under review",
      edit: "Edit Application",
      loan: "Loan Process",
      uploaded: "Uploaded Files",
      business: "Black Business Registration & Mapping",
    },
    application: {
      docs: {
        financial_statement_file: "Financial Statement",
        business_plan_file: "Business Plan",
        personal_net_worth_statement: "Personal Net worth Statement",
        personal_net_worth_statement_pdf:
          "https://storage.googleapis.com/face-api-public-assets/personal-networth-statement_rv1.pdf",
        income_tax_filed_up_to_date_file: "Tax Return & Notice of Assessment",
      },
      conversations: "Conversations",
      documents: "Documents",
      process:
        "For us to process your application, we require a minimum of these three documents. You can still submit your application and send us these documents at a later date.",
    },
    action: {
      submit: "Submit",
    },
    verification: {
      dashboard: "Go back to dashboard",
      congrat: "Congrats! You successfully verified your mobile number.",
      check: "Please check your phone for the verification code.",
      valid: "A valid four digit verification code is required.",
      required: "Valid mobile number is required. xxx-xxx-xxxx",
      sendCode: "Send verification code",
      sending: "Sending verification",
      verify: "Verify Code",
      code: "Verification code",
      success: "Verification successful",
      mobile: "Enter your mobile number",
      process: "SMS verification process",
      enterMobile: "Please enter your mobile number to verify by SMS",
    },
    footer: {
      complete: "Complete",
      questions: "Questions",
      documents: "Documents",
      missing: "Missing documents",
      conversations: "Conversations",
      msg: "New messages",
    },
  },
  fr: {
    completed: "Document soumis",
    partner: {
      heading: "Partenaires de l'écosystème de la FACE",
      link: "Visitez",
    },
    consent: {
      reapply: {
        selection:
          "Vous devez sélectionner une raison pour poursuivre la demande.",
        selection_zero: "Sélectionnez une raison",
        selection_one:
          "J'ai mis à jour les informations financières ou fiscales de mon entreprise pour soutenir une nouvelle demande de prêt.",
        selection_two:
          "J'ai reçu un prêt de FACE et je dépose une demande pour plus de capital.",
        error: "Vous devez consentir à poursuivre la demande.",
        button: "Réappliquer",
        reason:
          "Veuillez sélectionner ci-dessous la raison de votre nouvelle demande de prêt.",
        heading: "En soumettant cette demande,",
        row1: "J'autorise/nous autorisons FACE à obtenir des rapports de solvabilité et toute information dont elle pourrait avoir besoin dans le cadre de cette demande de crédit et de toute mise à jour, augmentation, renouvellement, extension ou recouvrement du crédit reçu, auprès d'autres sources (par exemple, bureau de crédit) et chacune de ces sources est autorisée par la présente à leur fournir ces informations.",
        row2: "Je/Nous certifions par la présente que les informations fournies dans la demande sont véridiques et correctes et je/nous comprenons que FACE se basera sur les informations contenues dans cette demande et sur mes rapports de solvabilité pour prendre sa décision.",
        row3: "Je reconnais/Nous reconnaissons que toute nouvelle demande de prêt qui ne contient aucune modification ou mise à jour peut faire l'objet d'un refus immédiat.",
        row4: "Je/Nous reconnaissons que je/nous sommes entièrement responsables et serons tenus entièrement responsables si je/nous fournissons volontairement et délibérément des informations incomplètes ou incorrectes sur les demandes de prêt faites à la FACE.",
      },
      mandatory: "* Obligatoire",
      heading: "Consentement de l'utilisateur",
      check: "Cochez cette case si vous y consentez.",
      error:
        "Vous devez consentir à la section obligatoire pour poursuivre la demande.",
      button: "J’autorise",
      cancel: "Cancel",
      one: {
        heading: "Informations pour l’inventaire des entreprises",
        info: "J’autorise que les informations à propos de mon entreprise dans cette section puissent être utilisés afin qu’elle puisse être listée et affiche sur la plateforme de FACE pour une utilisation publique.",
      },
      two: {
        heading: "Questionnaire à propos des informations personnelles",
        info: "Je suis conscient que toutes les questions contenues dans cette section sont facultatives et ne seront pas partagées ou utilisées dans le cadre de l'évaluation de ma demande de prêt auprès de FACE.",
      },
      three: {
        heading: "Informations à propos de l’entreprise et les actionnaires",
        info: "Je suis conscient que toutes les questions contenues dans cette section sont obligatoires et que la documentation demandée est requise pour être en mesure de soumettre la demande de prêt auprès de FACE.",
      },
    },
    question: {
      shareholders: "Informations sur les actionnaires commerciaux",
      required:
        "Informations sur les actionnaires commerciaux est obligatoire.",
      input: {
        name: "Nom complet",
        email: "Adresse courriel",
        dob: "Date de naissance?",
        address: "Adresse de l'entreprise",
        share: "Partager",
      },
    },
    menu: {
      home: "Accueil",
      login: "Connexion",
      logout: "Sign out",
      settings: "Paramètres",
      profile: "Votre profil",
      profile2: "Profil",
      dashboard: "Dashboard",
      resources: "Ressources",
      privacy: "Intimité",
      security: "Sécurité",
      faq: "FAQ",
      help: "Aider",
      legal: "Légale",
    },
    locale: "fr",
    faq: "Faq",
    "app-file": "Formulaire PDF à remplir",
    "personal-networth": "État de la valeur nette personnelle",
    legal: "Légale",
    copyright: "FACE - Federation of African Canadian Economics",
    security: "Sécurité",
    privacy: "Intimité",
    help: "Aider",
    login: "Connexion",
    logout: "Se déconnecter",
    input: {
      type: "Tapez quelque chose ici...",
      delete: "Effacer",
      btnpreview: "Aperçu",
      preview: "Prévisualisez votre documentation téléchargée.",
      update: "Réviser",
      edit: "Edit",
      allq: "Toutes les questions",
      alld: "Tous les documents",
      uploadedd: "Documents téléchargés",
      uploaddoc: "Téléchargez votre document",
      oops: "Oups!",
      required: "Cette question est obligatoire.",
      requiredAmount: "Le montant du prêt doit être supérieur ou égal à 10 000 $",
      enter: "Entrer",
      save: "Sauvegarder",
      saving: "Économie",
      continue: "Continuer",
      skip: "Ignorer la question",
    },
    drop: "Chargez votre document",
    drop2: "Chargez votre document",
    upload: "Télécharger",
    download: "Télécharger le document",
    cancel: "Annuler",
    continue: "Continuer",
    reply: "Répondre",
    complete: "Compléter",
    files: "Des dossiers",
    questions: "Des questions",
    questionsTotal: "Le total",
    questionsRequired: "Obligatoire",
    response: "Réponse",
    dashboard: {
      "loan-app": "Demande de prêt",
      submitted: "Date de soumission ",
      enable: "Activer",
      "sms-info":
        "Découvrez comment la fraude affecte les entreprises et les stratégies que vous pouvez adopter pour prévenir les abus de nouveaux comptes, les prises de contrôle de comptes et les fraudes sur les transactions.",
      "upload-doc": "Téléchargez votre document",
      status: {
        review: "Nos agents examinent actuellement votre dossier.",
      },
      process: "État de la candidature",
      "edit-app": "Modifier l'application",
      "start-app": "Démarrer l'application",
      "mapping-title": "ENREGISTREMENT ET CARTOGRAPHIE DES ENTREPRISES NOIRES",
      "mapping-sub":
        "Augmentez la visibilité de votre entreprise et répertoriez votre entreprise ou vos services via FACE Coalition.",
      of: "of",
      "notify-sms": "Me prévenir par SMS",
      edit: "Modifier l'application",
      sub: "Augmentez la visibilité de votre entreprise et répertoriez votre entreprise ou vos services via FACE Coalition.",
      review: "À l'étude",
      loan: "Processus de prêt",
      uploaded: "Fichiers téléchargés",
      business: "Enregistrement et cartographie des entreprises noires",
      comm: "Demandes",
    },
    application: {
      docs: {
        financial_statement_file: "État financier",
        business_plan_file: "Plan d'affaires",
        personal_net_worth_statement:
          "Déclaration de la valeur nette personnelle",
        personal_net_worth_statement_pdf:
          "https://storage.googleapis.com/face-api-public-assets/personal-networth-statement_rv1.pdf",
        income_tax_filed_up_to_date_file: "Déclaration d'impôt sur le revenu",
      },
      conversations: "Conversations",
      documents: "Documents",
      process:
        "Pour traiter votre demande, nous avons besoin d’un minimum de ces trois documents. Vous pouvez toujours soumettre votre demande et nous faire parvenir ces documents à une date ultérieure.",
    },
    action: {
      submit: "Soumettre",
    },
    verification: {
      dashboard: "Retourner au tableau de bord",
      congrat:
        "Félicitations! Vous avez vérifié avec succès votre numéro de téléphone mobile.",
      success: "Vérification réussie",
      check: "Veuillez vérifier le code de vérification sur votre téléphone.",
      valid: "Un code de vérification valide à quatre chiffres est requis.",
      required: "Un numéro de téléphone mobile valide est requis. xxx-xxx-xxxx",
      sendCode: "Envoyer le code de vérification",
      sending: "Envoi de la vérification",
      verify: "Vérifier le code",
      code: "Code de vérification",
      mobile: "Entrez votre numéro de téléphone mobile",
      process: "Processus de vérification du SGS",
      enterMobile:
        "Veuillez saisir votre numéro de portable à vérifier par SMS",
    },
    footer: {
      complete: "Compléter",
      questions: "Des questions",
      documents: "Documents",
      missing: "Documents manquants",
      conversations: "Conversations",
      msg: "Nouveaux messages",
    },
  },
};

const i18n = createI18n({
  locale: window.currentLang ? window.currentLang : "en",
  messages: messages,
});

export default i18n;
